<template>
   <div class="px-2">
        <v-card tile outlined class="custom_courses-card">
            <v-toolbar flat>
                <v-toolbar-title><b>Season Discounts</b></v-toolbar-title>
                    <v-spacer></v-spacer>
                        <router-link to="/admin/addseasonaldiscount" style="text-decoration:none;">
                            <v-btn color="secondary" type="submit">
                                Add Discount
                            </v-btn>
                        </router-link>
                </v-toolbar>
                <div class="custom-bg_courses">
                    <v-row class="pa-2" no-gutters>
                        <v-spacer></v-spacer>
                        <div class="mr-3"> Search: </div>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field
                                prepend="search"
                                type="text"
                                dense
                                v-model="search"
                                single-line
                                hide-details
                                outlined
                                no-gutters
                                height="5"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-data-table
                        dense
                        fixed-header
                        :headers="headers" 
                        bold
                        :items="discounts"
                        :items-per-page="10"
                        sort-by="['serialNum', 'name', 'discountPercentage','couponCode']"
                        :search="search"
                    >

                        <template v-slot:item.serialNum="{item}">
                            {{discounts.indexOf(item)+1}} 
                        </template>
        

                        <template v-slot:item.edit_deleteDetails="{item}"> <!--to="'/admin/courseinfoedit/'+item._id" -->
                           <v-tooltip bottom>
                                <template v-slot:activator="{on}">
                                    <v-icon
                                        class="mr-2"
                                        color="blue darken-3"
                                        v-on="on"
                                        @click="goToDiscountInfoEdit(item)"
                                        >mdi-pencil
                                    </v-icon>
                                </template>
                                <span>View Details</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{}">
                                    <v-icon
                                        class="mr-2"
                                        color="blue darken-3"
                                        v-on:click="deleteDiscount(item._id, discounts.indexOf(item))"
                                        >mdi-delete
                                    </v-icon>    
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </div>
</template>

<script>

import SeasonalDiscount from "../../models/SeasonalDiscount";
import { mapMutations } from "vuex";
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                  {
                       vm.$router.push("/");
                  } 
            }, 0);
        });
    },
    name: "SeasonalDiscounts",
    data() {
        return {
            search:'',
            headers: [
                { text: "S.No", value: "serialNum" },
                { text: "Discount Name", value: "name" },
                { text: "Percentage", value: "discountPercentage" },
                { text: "Coupon Code", value: "couponCode" },
                { text: "Start Date", value: "startDate" },
                { text: "End Date", value: "endDate" },
                { text: "Status", value: "status" },
                { text: "", value: "edit_deleteDetails" }
            ],
            discounts: [],
            seasonaldiscount: new SeasonalDiscount(),
            errorMessage: "",
            };
    },

    methods: {
         ...mapMutations(["setSeasonalDiscount"]),

        getDiscounts() {
            SeasonalDiscount.get(this.auth.token)
                .then(res => {
                this.discounts = res.data;
                console.log('all',this.discounts)
                })
                .catch(err => console.error(err.response.data));
        },


        
        deleteDiscount(discount_id, index)
        {
            console.log('index', index);
            SeasonalDiscount.deleteDiscount(discount_id, this.auth.token).then(res=>
            {
                console.log(res.data);
               // let index=this.courses.indexOf(item=>item._id===course_id);
                //console.log('index', index);
                this.discounts.splice(index, 1);
                this.getDiscounts();

            }).catch(err => console.error(err.response.data));
            
        },

        goToDiscountInfoEdit(discountItem){
            this.setSeasonalDiscount(discountItem);
            this.$router.replace("/admin/seasonalinfoedit");
            
        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        },
        
    },
    // watch:{},

    mounted() {
        this.getDiscounts();
    }
 }

</script>

<style scoped>

.v-data-table {
    line-height: 3.5;
}
.theme--light.v-card {
    background: transparent;
    border: 0;
}
.custom_courses-card >>> header {
    background: transparent !important;
}
.custom_courses-card >>> header .v-toolbar__content {
    padding: 0;
}
.custom-bg_courses {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 3px solid #d2d6de;
}
.custom_courses-card >>> .v-data-table-header__icon {
    margin-left: 10px;
}
.custom_courses-card >>> .v-data-table-header > tr > th {
    font-size: 14px;
    padding:0 4px;
}
.custom_courses-card >>> .v-data-footer {
    margin: 0;
    font-size: 14px;
}
.custom_courses-card >>> .v-input__slot {
    min-height: 32px !important;
}
.custom_courses-card >>> table{
    border-radius: 0;
    border-collapse: collapse;
    border:0!important;
}
.custom_courses-card >>> table tr td,
.custom_courses-card >>> table tr th {
    border: 1px solid rgba(0, 0, 0, 0.12)!important;
    box-shadow: none!important;
}
.custom_courses-card >>> .v-data-table__wrapper table  tbody > tr > td:last-child,
.custom_courses-card >>> .v-data-table__wrapper table  thead > tr > th:last-child{
    text-align: center!important;
}
.custom_courses-card >>> .v-data-footer{
    border:0;
}
@media only screen and (max-width:992px){
    .custom_courses-card >>> .v-data-table-header > tr > th {
        font-size:12px;
    }
     .custom_courses-card >>> .v-data-table-header > tr > th:first-child {
         min-width: 65px;
     }
     .custom_courses-card >>> .v-data-table-header > tr > th:nth-child(2), .custom_orders-card >>> .v-data-table-header > tr > th:nth-child(3) {
         min-width: 105px;
     }
}
</style>
